<body *ngIf="background1" id="register_bg">
  <div class="o_authpage">
    <ul style="width: 600px;">
      <li>
        <img src="/assets/img/logo-login.png" alt="Logo" class="logo_sticky" height="60">
      </li>
      <li *ngIf="error" class="alert-danger messagebox warning-msg-box" style="margin: 5px;" role="alert">{{ error }}</li>
      <form [formGroup]="form" (ngSubmit)="authorize()">
        <li>
          <input type="email" class="form-control" 
            [ngClass]="{ 'is-invalid': emailControl.invalid && emailControl.touched }"
            formControlName="email" placeholder="Email">
          <ng-container *ngIf="emailControl.touched || emailControl.dirty">
            <small class="text-danger" *ngIf="emailControl.hasError('required')">Email is required</small>
            <small class="text-danger" *ngIf="emailControl.hasError('email')">Email must be a valid email address</small>
          </ng-container>
        </li>
        <li style="margin-top: 5px;">
          <input type="password" class="form-control" 
            [ngClass]="{ 'is-invalid': passwordControl.invalid && passwordControl.touched }"
            formControlName="password" placeholder="Password">
          <small class="text-danger" *ngIf="passwordControl.hasError('required') && (passwordControl.touched || passwordControl.dirty)">
            Password is required
          </small>
        </li>
        <li>
          <button class="btn btn-primary mb-2 px-4" style="width: 180px;" type="submit">
            <span>Login to {{organizationName}}</span>
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm float-right"></span>
          </button>
        </li>
      </form>
      <li style="margin-top: 50px;">
        © {{year}} {{organizationName}}
      </li>
    </ul>
  </div>
</body>

<body *ngIf="background2" id="boyd_bg">
  <div class="o_authpage">
    <ul style="width: 600px;">
      <li>
        <img src="/assets/img/boyd_gaming_logo.jpg" alt="Logo" class="logo_sticky" height="60" style="margin-bottom: 50px;margin-top: 10px;">
      </li>
      <li *ngIf="error" class="alert-danger messagebox warning-msg-box" style="margin: 5px;" role="alert">{{ error }}</li>
      <form [formGroup]="form" (ngSubmit)="authorize()">
        <li>
          <input type="email" class="form-control" 
            [ngClass]="{ 'is-invalid': emailControl.invalid && emailControl.touched }"
            formControlName="email" placeholder="Email">
          <ng-container *ngIf="emailControl.touched || emailControl.dirty">
            <small class="text-danger" *ngIf="emailControl.hasError('required')">Email is required</small>
            <small class="text-danger" *ngIf="emailControl.hasError('email')">Email must be a valid email address</small>
          </ng-container>
        </li>
        <li style="margin-top: 5px;">
          <input type="password" class="form-control" 
            [ngClass]="{ 'is-invalid': passwordControl.invalid && passwordControl.touched }"
            formControlName="password" placeholder="Password">
          <small class="text-danger" *ngIf="passwordControl.hasError('required') && (passwordControl.touched || passwordControl.dirty)">
            Password is required
          </small>
        </li>
        <li>
          <button class="btn btn-primary mb-2 px-4" style="width: 80px;" type="submit">
            <span>Login</span>
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm float-right"></span>
          </button>
        </li>
      </form>
      <li style="margin-top: 50px;">
        © {{year}} {{organizationName}}
      </li>
    </ul>
  </div>
</body>